var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{staticClass:"resales-bookings",attrs:{"title":_vm.$t('global.bookings-list'),"text":_vm.$t('resalesBookings.description'),"name":"resalesBookings","url":_vm.$listRoutes.resalesBookings,"table":_vm.resalesBookings,"filters":_vm.resalesBookingsFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }